module.exports = __webpack_public_path__ + "img/sponsor-ank.5948f0d1.png";